import styled from "styled-components";
import { theme } from "styles/mui-config";

export const StyledCircle = styled.span`
  transition: all 0.3s cubic - bezier(0.65, 0, 0.076, 1);
  position: relative;
  display: block;
  margin: 0;
  width: 3rem;
  height: 3rem;
  transition: 0.3s;
  background: ${theme.palette.primary.main};
  border-radius: 1.625rem;
`;

////////////////////////////////////////
export const StyledArrow = styled.span`
  transition: all 0.3s cubic-bezier(0.65, 0, 0.076, 1);
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  background: #fff;

  transition: all 0.3s cubic-bezier(0.65, 0, 0.076, 1);
  left: 0.625rem;
  width: 1.125rem;
  height: 0.125rem;
  background: none;

  &::before {
    position: absolute;
    content: "";
    top: -0.29rem;
    right: 0.0625rem;
    width: 0.625rem;
    height: 0.625rem;
    border-top: 0.125rem solid #fff;
    border-right: 0.125rem solid #fff;
    transform: rotate(45deg);
  }
`;

///////////////////////////////////////
export const StyledBtnText = styled.span`
  transition: all 0.3s cubic-bezier(0.65, 0, 0.076, 1);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0.75rem 0;
  margin: 0 0 0 1.85rem;
  color: #282936;
  font-weight: 700;
  line-height: 1.6;
  text-align: center;
  text-transform: uppercase;
  @media (max-width: 900px) {
    display: none;
  }
`;

///////////////////////////////////////////
export const StyledBackBtn = styled.button`
  position: relative;
  direction: ltr !important;
  display: inline-block;
  cursor: pointer;
  outline: none;
  border: 0;
  vertical-align: middle;
  text-decoration: none;
  background: transparent;
  padding: 0;
  font-size: inherit;
  font-family: inherit;
  width: 12rem;
  height: auto;
  &:hover ${StyledCircle} {
    width: 100%;
  }
  &:hover ${StyledArrow} {
    background: #fff;
    transform: translate(1rem, 0);
  }
  &:hover ${StyledBtnText} {
    color: #fff;
  }
  @media (max-width: 900px) {
    width: 3.5rem;
  }
`;
